/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

const React = require('react');
const { initialAuthUserFromCookie } = require('./src/utils/sso');
const CookieBanner = require('./src/components/CookieBanner').default;

exports.onClientEntry = () => {
  const auth = initialAuthUserFromCookie();
  if (auth && window.analytics) {
    const { email } = auth;
    window.analytics.identify(email, { email });
  }
};

exports.wrapRootElement = ({ element }) => (
  <>
    {element}
    <CookieBanner />
  </>
);
